import { EntityForm } from "../../components/entityForm/EntityForm";
import { Record } from "../../components/record/Record";
import { Records } from "../../components/records/Records";
import { ScheduledTasksForm } from "./ScheduledTasksForm";
import { ScheduleSummary } from "./ScheduleSummary";
import { ScheduledTasksGroups } from "./ScheduledTasksGroups";
import { ScheduledTasksDetailHeader } from "./ScheduledTasksDetailHeader";
import { ScheduledTasksEditGuard } from "./ScheduledTasksEditGuard";
import { scheduledTasksDetailGroupsOptions, scheduledTasksOptions } from "./scheduledTasksOptions";

const fieldsQuery = "*.*,assigned_users.*,participant_users.directus_users_id.*";

export const scheduledTasksRoutes = [
    {
        path: "/scheduled_tasks",
        element: (
            <Records entity="scheduled_tasks" fieldsQuery={fieldsQuery} options={scheduledTasksOptions} heightOfHeaders={190} />
        ),
    },
    {
        path: "/scheduled_tasks/:id/detail",
        element: (
            <Record
                entity="scheduled_tasks"
                type="detail"
                fieldsQuery={fieldsQuery}
                options={scheduledTasksOptions.groupsOptions}
                header={<ScheduledTasksDetailHeader />}
                body={
                    <>
                        <ScheduleSummary />
                        <ScheduledTasksGroups groupsOptions={scheduledTasksDetailGroupsOptions} />
                    </>
                }
            />
        ),
    },
    {
        path: "/scheduled_tasks/:id/update",
        element: (
            <Record
                entity="scheduled_tasks"
                type="update"
                fieldsQuery={fieldsQuery}
                options={scheduledTasksOptions.groupsOptions}
                body={
                    <ScheduledTasksEditGuard>
                        <EntityForm groupsOptions={scheduledTasksOptions.groupsOptions} component={<ScheduledTasksForm />} />
                    </ScheduledTasksEditGuard>
                }
            />
        ),
    },
    {
        path: "/scheduled_tasks/create",
        element: (
            <Record
                entity="scheduled_tasks"
                type="create"
                fieldsQuery={fieldsQuery}
                options={scheduledTasksOptions.groupsOptions}
                body={<EntityForm groupsOptions={scheduledTasksOptions.groupsOptions} component={<ScheduledTasksForm />} />}
            />
        ),
    },
];
